import React from 'react';
import { Video, AlertCircle, Maximize2 } from 'lucide-react';
import styles from './Cameras.module.css';

const Cameras = () => {
  const cameras = [
    { id: 1, name: 'Main Gate Entry', status: 'Online', feed: 'https://images.unsplash.com/photo-1549880181-56a44cf4a9a5?q=80&w=600&auto=format&fit=crop' },
    { id: 2, name: 'Main Gate Exit', status: 'Online', feed: 'https://images.unsplash.com/photo-1549880181-56a44cf4a9a5?q=80&w=600&auto=format&fit=crop' },
    { id: 3, name: 'Tower A Lobby', status: 'Online', feed: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=600&auto=format&fit=crop' },
    { id: 4, name: 'Tower B Lobby', status: 'Online', feed: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=600&auto=format&fit=crop' },
    { id: 5, name: 'Basement Parking 1', status: 'Offline', feed: null },
    { id: 6, name: 'Clubhouse Entrance', status: 'Online', feed: 'https://images.unsplash.com/photo-1577223625816-75b6f0923186?q=80&w=600&auto=format&fit=crop' },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.pageHeader}>
        <div>
          <h1>Camera Monitoring</h1>
          <p>Live CCTV feeds across the society premises</p>
        </div>
      </div>

      <div className={styles.grid}>
        {cameras.map(cam => (
          <div key={cam.id} className={styles.camCard}>
            <div className={styles.feedWrapper}>
              {cam.status === 'Online' ? (
                <>
                  <img src={cam.feed} alt={cam.name} className={styles.feedImage} />
                  <div className={styles.overlay}>
                    <span className={styles.liveTag}><span className={styles.dot}></span> LIVE</span>
                    <button className={styles.fullscreenBtn} title="Fullscreen"><Maximize2 size={16} /></button>
                  </div>
                </>
              ) : (
                <div className={styles.offlineFeed}>
                  <AlertCircle size={32} color="#9ca3af" />
                  <span>Signal Lost / Offline</span>
                </div>
              )}
            </div>
            <div className={styles.camInfo}>
              <Video size={16} className={cam.status === 'Online' ? styles.iconOnline : styles.iconOffline} />
              <strong>{cam.name}</strong>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Cameras;
